const React = require('react');

const CommonTypes = require('../common/Types.jsx');
const Config = require('../utility/Config.jsx');
const Item = require('../common/ItemV2.jsx');
const Name = require('../utility/Name.jsx');
const Content = require('../common/Content.jsx');
const Token = require('../utility/Token.jsx');
const TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region META

function _Meta(props) {
    const hasValue = !Utilities.isHTMLContentEmpty(props.content);
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const Meta = Content.withLabelTokenParsing(_Meta, Token.TypeParsing.artist);
const TokensMeta = (data) => {
    return [
        Token.getWrappedTokenConfig('Artist Name', Token.Artist.Name),
        Token.getWrappedTokenConfig('Birthdate', Token.Artist.Birthdate),
        Token.getWrappedTokenConfig('Deathdate', Token.Artist.Deathdate),
        Token.getWrappedTokenConfig('Biography', Token.Artist.Biography),
        Token.getWrappedTokenConfig('Curriculum Vitae', Token.Artist.CurriculumVitae)
    ]
}
const TypeConfigMeta = {
    defaultDesign: `${Utilities.wrapTextForEditor({ text: `{${Token.Artist.Name}("before":"","after":"")}`, token: Token.Artist.Name })}`,
    panel: {
        block: () => Content.TypeConfig.labelValue.panelV2.block(1),
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: Content.TypeConfig.labelValue.panelV2.label,
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: (data) => Content.TypeConfig.labelValue.panelV2.value(TypeConfigMeta.defaultDesign)
    }
};

// #endregion META

module.exports = {
    Component: Meta,
    Tokens: TokensMeta,
    TypeConfig: TypeConfigMeta
}